import React from 'react';
import { Circle, G, Line, Path, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** ELA = Q_ref / (Cd · √(2ΔP/ρ)) — distributed cracks ≡ single equivalent hole. */
export function DiagramBETEffectiveLeakageArea() {
  return (
    <DiagramCanvas>
      {/* Left: wall with many cracks */}
      <Rect x={40} y={50} width={110} height={175} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {/* Brick/stud hatch */}
      {[0, 1, 2, 3, 4, 5].map(i => (
        <Line key={i} x1={40} y1={70 + i * 28} x2={150} y2={70 + i * 28} stroke={DT.stroke} strokeWidth="0.4" opacity={0.4} />
      ))}
      <SvgText x={95} y={42} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">actual envelope</SvgText>

      {/* Many small cracks with flow arrows */}
      {[
        [52, 62], [75, 78], [100, 90], [130, 72], [60, 110], [95, 125], [125, 115],
        [52, 145], [85, 160], [118, 150], [70, 180], [110, 195], [135, 210], [55, 210],
      ].map(([x, y], i) => (
        <G key={i}>
          <Path d={`M${x},${y} l-3,-3 l5,1 l-2,-4`} fill="none" stroke={DT.varColor} strokeWidth="1.1" />
          <Circle cx={x} cy={y} r={1.5} fill={DT.varColor} />
          <Line x1={x} y1={y} x2={x - 6} y2={y - 2} stroke={DT.varColor} strokeWidth="0.8" opacity={0.7} />
          <Polygon points={`${x - 6},${y - 2} ${x - 3},${y - 5} ${x - 3},${y}`} fill={DT.varColor} opacity={0.7} />
        </G>
      ))}

      {/* Equivalence symbol */}
      <G>
        <Line x1={160} y1={135} x2={195} y2={135} stroke={DT.leader} strokeWidth="1.4" />
        <Line x1={160} y1={142} x2={195} y2={142} stroke={DT.leader} strokeWidth="1.4" />
        <Line x1={160} y1={128} x2={195} y2={128} stroke={DT.leader} strokeWidth="1.4" />
        <SvgText x={178} y={118} fill={DT.leader} fontSize="9" fontFamily={DT.mono} textAnchor="middle">equivalent</SvgText>
        <Polygon points={`195,135 188,131 188,139`} fill={DT.leader} />
      </G>

      {/* Right: single equivalent hole in same-size wall */}
      <Rect x={205} y={50} width={110} height={175} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.8" />
      {[0, 1, 2, 3, 4, 5].map(i => (
        <Line key={i} x1={205} y1={70 + i * 28} x2={315} y2={70 + i * 28} stroke={DT.stroke} strokeWidth="0.4" opacity={0.4} />
      ))}
      {/* Single hole (ELA) */}
      <Rect x={245} y={115} width={30} height={45} fill="rgba(255,107,26,0.28)" stroke={DT.varColor} strokeWidth="1.8" />
      {/* Arrow through hole */}
      <Line x1={232} y1={137} x2={244} y2={137} stroke={DT.varColor} strokeWidth="1.6" />
      <Polygon points={`244,137 238,133 238,141`} fill={DT.varColor} />
      <SvgText x={260} y={108} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">ELA</SvgText>
      <SvgText x={260} y={170} fill={DT.desc} fontSize="7" fontFamily={DT.mono} textAnchor="middle">(in² or cm²)</SvgText>
      <SvgText x={260} y={42} fill={DT.desc} fontSize="9" fontFamily={DT.mono} textAnchor="middle">equivalent hole</SvgText>

      {/* Legend / Cd */}
      <Rect x={20} y={230} width={310} height={16} fill="rgba(0,0,0,0.5)" />
      <SvgText x={30} y={242} fill={DT.desc} fontSize="8" fontFamily={DT.mono}>Cd ≈ 1.0 (sharp-edged)</SvgText>
      <SvgText x={170} y={242} fill={DT.desc} fontSize="8" fontFamily={DT.mono}>ρ_air ≈ 1.2 kg/m³</SvgText>
      <SvgText x={280} y={242} fill={DT.varColor} fontSize="8" fontFamily={DT.mono}>ΔP_ref = 4 Pa</SvgText>

      {/* Labels */}
      <LeaderLine x1={95} y1={135} x2={22} y2={60} varName="cracks" desc="distributed leaks" anchor="start" />
      <LeaderLine x1={260} y1={115} x2={335} y2={60} varName="ELA" desc="equivalent hole area" anchor="end" />

      <FormulaTag formula="ELA = Q_ref / (Cd · √(2·ΔP_ref / ρ))" />
    </DiagramCanvas>
  );
}
